module.exports = __webpack_public_path__ + "static/img/8.7fa2ac2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/zh/8.png
// module id = xsHt
// module chunks = 0